import { render, staticRenderFns } from "./Beweglichkeit.vue?vue&type=template&id=dccd36d0&"
import script from "./Beweglichkeit.vue?vue&type=script&lang=js&"
export * from "./Beweglichkeit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports